import { createFileRoute, Outlet } from '@tanstack/react-router';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client')({
  beforeLoad: clientGuard,
  component: ClientRoute,
});

function ClientRoute() {
  return <Outlet />;
}
